// extracted by mini-css-extract-plugin
module.exports = {"root":"F-docs-layout-root-29xuX","main":"F-docs-layout-main-3KQ_P","skipToMain":"F-docs-layout-skip-to-main-2bY7d"};